import {createContext} from "react";
import type {Account} from "@novel/contracts";

export interface SessionState {
  readonly offline:boolean;
  readonly isSigningOut:boolean;
  readonly account:Account|undefined;
  readonly isLoading:boolean;
  readonly isAuthenticated:boolean;
  refresh():Promise<void>;
  signOut():Promise<void>;
}

// Keep context identity stable when the provider's syncing implementation is
// hot-reloaded during development. Consumers and provider share this module.
export const SessionContext=createContext<SessionState|undefined>(undefined);
